import Message from '../model/Message'

export const CHAT_EMOJI_OPTIONS = ['👍', '❤️', '😂', '🎉', '🔥', '💪']

export function isLastInChain(messages: Message[], index: number): boolean {
  if (index === messages.length - 1) return true

  const currentMessage = messages[index]!
  const nextMessage = messages[index + 1]!
  const currentIsActivity = !!currentMessage.activityLogId
  const nextIsActivity = !!nextMessage.activityLogId

  if (currentIsActivity || nextIsActivity) return true
  return currentMessage.user.id !== nextMessage.user.id
}

export function isFirstInChain(messages: Message[], index: number): boolean {
  if (index === 0) return true

  const currentMessage = messages[index]!
  const previousMessage = messages[index - 1]!
  const currentIsActivity = !!currentMessage.activityLogId
  const previousIsActivity = !!previousMessage.activityLogId

  if (currentIsActivity || previousIsActivity) return true
  return currentMessage.user.id !== previousMessage.user.id
}

export function formatActivityAmount(amount: number, unitConversion: number): string {
  const rawValue = amount / unitConversion
  const rounded = Math.round(rawValue * 1000) / 1000
  const nearestWhole = Math.round(rounded)
  const difference = Math.abs(rounded - nearestWhole)
  const normalizedValue = difference <= 0.005 ? nearestWhole : parseFloat(rounded.toFixed(3))
  return normalizedValue.toString()
}
